<template>
  <!-- 揭西县人民医院 -->
  <div class="pageContent">
    <img
      src="../../../assets/ezhou.png"
      alt="Login logo"
      class="loginLogo"
    />
    <div class="hosName">鄂州市中心医院</div>
    <div class="ourterTitle">输入姓名/手机号绑定数字影像</div>
    <div class="bindDetails">
      <div class="IDNumber">
        <van-field
          v-model="value43600001.name43600001"
          placeholder="请输入姓名"
          @input.native="inputFn"
        />
      </div>
      <!-- <div class="IDNumber">
        <van-field
          v-model="value43600001.value1"
          placeholder="请输入身份证绑定信息"
          @input.native="inputFn"
        />
      </div> -->
       <div class="IDNumber">
        <van-field
          style="margin-top:20px"
          v-model="value43600001.phone43600001"
          placeholder="请输入手机号"
          @input.native="phoneFn"
        />
      </div>
      <div class="code">
        <van-field
          class="codeInput"
          v-model="phoneCode"
          type="number"
          placeholder="请输入4位验证码"
          @input.native="inputFn"
          maxlength="4"
        />
        <van-button
          class="toObtain"
          :style="{color: codeBool?'rgba(255,255,255,.8)':'rgb(19, 172, 193)'}"
          :disabled="codeBool"
          @click.native="getsendSms"
          type="default"
          >{{ innerText }}</van-button
        >
      </div>
      <footer class="footer">
        <van-button type="primary" :disabled="rules" @click.native="getCheckCaptcha"
          >下一步</van-button
        >
      </footer>
    </div>
  </div>
</template>
<script>
import { dockSendSms, dockCheckCaptcha } from "@/api/login";
import Storage from "@/tools/storage";
export default {
  data() {
    return {
      value43600001: {
        name43600001: "",
        phone43600001: "",
      },
      
      rules: true,
      phoneCode: "",
      codeBool: true,
      innerText: "获取验证码",
    };
  },
  methods: {
    phoneFn() {
      if (this.value43600001.phone43600001 && /^1[3|4|5|7|8][0-9]{9}$/.test(this.value43600001.phone43600001)) {
        this.codeBool = false;
        return;
      } else {
        this.codeBool = true;
      }
    },
    async getsendSms() {
      this.djsFn();
      let data = { phone: this.value43600001.phone43600001 };
      let res = await dockSendSms(data);
    },
    djsFn() {
      let timer = null;
      clearInterval(timer); //这句话至关重要
      let time = 60;
      let that = this;
      timer = setInterval(function() {
        if (time <= 0) {
          that.innerText = "";
          that.innerText = "重新获取";
          that.codeBool = false;
          clearInterval(timer);
        } else {
          that.codeBool = true;
          that.innerText = "";
          that.innerText = "剩余时间" + time + "秒";
          time--;
        }
      }, 1000);
    },
    inputFn() {
      if (this.value43600001.name43600001 != "" && this.phoneCode.length == 4 && this.value43600001.phone43600001) {
        this.rules = false;
      } else {
        this.rules = true;
      }
    },
    // onInputCode() {
    //   if (this.phoneCode.length == 4 && this.phone) {
    //     this.rules = false;
    //   } else {
    //     this.rules = true;
    //   }
    // },
    async getCheckCaptcha() {
      let data = {
        phone: this.value43600001.phone43600001,
        code: this.phoneCode,
      };
      let res = await dockCheckCaptcha(data);
      if (res) {
        this.nextFn();
      }
    },
    nextFn() {
      let institution_id = window.location.href.split("/checkInfoOuter/")[1];
      window.localStorage.setItem("value43600001", JSON.stringify(this.value43600001));
      window.localStorage.setItem("institution_id", institution_id);
      this.$router.push({
        path: "/reportListOuter",
      });
    },
  },
  created() {
    window.localStorage.clear();
    let institution_id = window.location.href.split("/checkInfoOuter/")[1];
    if (window.localStorage.getItem("name43600001")) {
      this.$router.push({
        path: "/reportListOuter",
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.pageContent {
  .loginLogo{
    width: auto!important;
  }
  .hosName {
    font-size: 20px;
    padding: 10px 0;
    font-weight: 800;
  }
  .ourterTitle {
    padding: 15px 15px 20px;
    font-size: 18px;
    font-weight: 500;
  }
  .bindDetails {
    width: 90%;
    margin: 0 auto;
  }
  .code {
    display: flex;
    margin-top: 20px;
  }
  .codeInput {
    width: 65%;
  }
  .toObtain {
    margin-left: 20px;
    // color: rgb(19, 172, 193);
    font-size: 14px;
  }
}
</style>
